import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { languages } from '../config'
import { useProfile } from '../api/hooks/profile';

export function useUserLanguage() {
  const { i18n } = useTranslation('common');
  const languageList = useLanguages();
  const { profile } = useProfile();

  const userLanguage = useMemo(() => {
    let userLanguage = languageList.find(lang => lang.value === profile?.language);
    
    if (!userLanguage) {
        userLanguage = languageList.find(lang => i18n?.language.includes(lang.value));
    }

    return userLanguage
  }, [profile, languageList, i18n.language])

  return [userLanguage, languageList];
}

export function useLanguages() {
  const { t} = useTranslation('common');
  const languageList = useMemo(() => {
      return languages.map(lang => ({
          ...lang,
          label: t(`languages.${lang.value}`)
      }))
  }, [t])

  return languageList;
}